module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEWSURBVEiJtdS/jwFBFAfw79uoqc+FUpSK1bs/4CYSimtFq6By5Tai5B/Y25JG4scfQK+5cmkl1NSSpyIEse/t+FYzk5n55CVvBhAm9I0b+saVnnMkm1d/pkGEJRGWq+C7+zYIoPZlyPS7DkzvPRDz5HaKZlRMBG03hyYzjTQYSSAAmHulxEcmNSTiys1FhH6uNm1Zg7SYCtJgakiKxYIkWGwoKiZ8sI/z5S2Ou83+51Hrn38QKxWd86wyZhStVHQdh5jv1hznaA2ae6XEZzY5YKB6vc7MrVxt/G+tGZ4h+fqsD1hq71dIbCgqEguSIGpIiqggDSKGtAgg/ILS2WRPg4ghAGUNIoaY0dEgqoS+cddBuSA9dwKhOLtEY2DLEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m2.png
// module id = KqoR
// module chunks = 1